import {
  deriveEventStatus,
  EVENT_STATUS_CLASSES,
  EVENT_STATUS_DESCRIPTIONS,
  EVENT_STATUS_LABELS,
  type EventStatusInput,
} from "@/lib/event-status";

// 134 #145 -- unified event status badge/legend. Replaces the old draft-only
// DraftPill. The state is derived purely from the event fields + now (see
// lib/event-status.ts); this component just renders the inverted-contrast pill
// with a tooltip describing the state. `data-status` is exposed for E2E.

interface EventStatusBadgeProps {
  event: EventStatusInput;
  /** Injectable clock for deterministic rendering/tests. Defaults to now. */
  now?: Date;
  className?: string;
}

export function EventStatusBadge({ event, now, className }: EventStatusBadgeProps) {
  const state = deriveEventStatus(event, now);
  return (
    <span
      data-status={state}
      title={EVENT_STATUS_DESCRIPTIONS[state]}
      className={`inline-flex w-fit items-center rounded-full px-2 py-0.5 text-xs font-medium ${EVENT_STATUS_CLASSES[state]} ${className ?? ""}`}
    >
      {EVENT_STATUS_LABELS[state]}
    </span>
  );
}
